<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <!-- <el-form-item label="客户名称:" prop="newCustomer">
                <el-select v-model="searchFrom.twoCustomerTaxId"  filterable remote placeholder="" default-first-option
                 :remote-method="xkhmcFn" value-key="taxpayerNumber" :loading="loading1">
                  <el-option v-for="(item,index) in customerList" :key="index" :label="item.custerName" :value="item.taxpayerNumber"> </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="所在仓库:" prop="organizationId">
                <el-select  v-model="searchFrom.organizationId"  placeholder="" @change="xuanzecangkuFN">
                  <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户名称:" prop="twoCustomerTaxId">
                <el-select  v-model="searchFrom.twoCustomerTaxId"  placeholder="请选择">
                  <el-option v-for="val in customerList" :label="val.secondaryCustomerName" :value="val.secondaryCustomerId" :key="val.secondaryCustomerId"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border v-if="tableArr.length>0">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div>
            <el-button type="text" size="mini"   v-if="btnFlg[0]"  @click="mingxiFN(scope.row)">库存明细</el-button>
              <el-button type="text" size="mini"  v-if="btnFlg[1]" @click="konghuoFN(scope.row)">控货</el-button>
              </div>
          </template>
        </el-table-column>
        <el-table-column prop="twoCustomerName"  min-width="280" :formatter="emptyFn" label="客户名称"></el-table-column>
        <el-table-column prop="organizationName"  min-width="200" :formatter="emptyFn" label="所在仓库"></el-table-column>
        <el-table-column property="totalAllWeight" label="总库存(吨/件)" min-width="200">
          <template scope="scope">
            <div>
           {{scope.row.totalAllWeight}}/{{scope.row.totalNumber}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalControlWeight" label="累计分配量(吨)" min-width="200" v-if="tableArr[0]">
          <!-- <template scope="scope">
            <div>
            <el-button type="text" size="mini"   @click="xiafaliangFN(scope.row)">{{scope.row.totalControlWeight}}</el-button>
            </div>
          </template> -->
        </el-table-column>
        <el-table-column property="totalAllWeight" label="未分配量(吨)" min-width="200" v-if="tableArr[0]">
          <template scope="scope">
            <div>
           {{scope.row.notIssuedControlWeight}}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 控货 -->
    <el-dialog title="控货" :close-on-click-modal="false" :visible.sync="KHdialog" @close="closeDialog"  width="450px" center>
      <span>
        <el-form :inline="true" :model="addFrom" ref="addFrom"  :rules="rules"  class="demo-form-inline jiaoyan" label-width="120px" size="mini">
        <div class="inpBox">
         <el-form-item label="增减类型:" prop="virtualControlType">
              <el-select v-model="addFrom.virtualControlType" placeholder="请选择">
                <el-option  label="增项" value="1" ></el-option>
                <el-option  label="减项" value="2" ></el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="控货重量:" prop="virtualControlWeight">
            <el-input  placeholder=""  v-number-input.float="4"   maxlength="10" v-model="addFrom.virtualControlWeight" ></el-input>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="KHdialog = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 控货明细 -->
    <el-dialog title="控货明细" :close-on-click-modal="false" :visible.sync="KHMXdialog" @close="closeDialog"  width="800px" center>
      <div>
        <div style="border-bottom: 1px dashed #ddd; margin-bottom: 10px;">
          <p>累计分配量：<span class="red">{{row.totalControlWeight}}</span>吨 </p>
        </div>
       <el-form :inline="true" v-model="MXsearchFrom"  class="demo-form-inline" label-width="90px" size="mini">
         <div class="searchBox inpBox">
            <el-form-item label="增减类型:" prop="billType">
              <el-select v-model="MXsearchFrom.virtualControlType" placeholder="请选择">
                <el-option  label="增项" value="1" ></el-option>
                <el-option  label="减项" value="2" ></el-option>
              </el-select>
            </el-form-item>
             <el-form-item>
                <el-button type="primary" @click="getMXList">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="MXresetForm">重置</el-button>
              </el-form-item>
        </div>
      </el-form>
       <el-table :data="KHMXList"  ref="table" v-loading="loading1"   bordersize="mini"
         style="width: 100%" height="300px"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="virtualControlNo"  min-width="200" :formatter="emptyFn" label="控货编号"></el-table-column>
        <el-table-column property="billType" label="增减类型" >
          <template scope="scope">
            <div>
           {{[ "增项", "减项",][scope.row.virtualControlType-1]}}
            </div>
          </template>
        </el-table-column>
         <el-table-column prop="virtualControlWeight"   label="数量"></el-table-column>
            <el-table-column prop="createUserName"   :formatter="emptyFn" label="创建人"></el-table-column>
         <el-table-column width="170" property="createTime" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
      <div>
      <el-pagination background
        @size-change="MXhandleSizeChange"
        @current-change="MXhandleCurrentChange"
        :current-page="MXsearchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="MXsearchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="MXtotla">
      </el-pagination>
    </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="KHMXdialog = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn, getAttribute } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { getCustomerlistByTenant } from '@/api/soc-stock'
import { cVirtualControlList, getOrganizationNameList, SVRlist, SVRadd, getTEmptyCargoControlList } from '@/api/soc-stock-cosco'
export default {
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber'),
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      KHdialog: false,
      addFrom: {},
      MXsearchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      loading1: false,
      KHMXdialog: false,
      KHMXList: [],
      MXtotla: 0,
      row: {},
      rules: {
        virtualControlType: [
          { required: true, message: '请选择增减类型', trigger: 'blur' }
        ],
        virtualControlWeight: [
          { required: true, message: '请输入货源量', trigger: 'blur' },
          this.rule.weight4
        ]
      },
      customerList: [],
      warehouseList: [],
      tableArr: [],
      btnFlg: [],
      btnIdArr: ['00UP001B001', '00UP001B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/ZYgoodsControl')
    this.searchFrom.oneCustomerTaxId = this.oneCustomerTaxId
    this.tableArr = getAttribute('ARRtotalAllWeight')
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }]
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
      getTEmptyCargoControlList({
        primaryCustomerTaxId: this.searchFrom.oneCustomerTaxId,
        organizationId: this.warehouseList[0].relTenantCode
      }).then(res => {
        this.customerList = JSON.parse(res)
      })
      this.getList(this.searchFrom)
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseList = res
        if (res.length > 0) {
          this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
          getTEmptyCargoControlList({
            primaryCustomerTaxId: this.searchFrom.oneCustomerTaxId,
            organizationId: res[0].relTenantCode
          }).then(res => {
            this.customerList = JSON.parse(res)
          })
        }
        this.getList(this.searchFrom)
      })
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 选择仓库
    xuanzecangkuFN () {
      getTEmptyCargoControlList({
        primaryCustomerTaxId: this.searchFrom.oneCustomerTaxId,
        organizationId: this.searchFrom.organizationId
      }).then(res => {
        this.customerList = JSON.parse(res)
        console.log(this.customerList)
      })
    },
    // 库存明细
    mingxiFN (row) {
      this.$router.push({ path: '/ZYgoodsRecord/inventoryDetails',
        query: { oneCustomerTaxId: row.oneCustomerTaxId,
          twoCustomerTaxId: row.twoCustomerTaxId,
          organizationId: row.organizationId } })
    },
    // 根据查询条件获取新客户列表
    xkhmcFn (query) {
      this.loading1 = true
      getCustomerlistByTenant({
        custerName: query,
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.loading1 = false
        this.customerList = res
      })
    },
    // 控货
    konghuoFN (row) {
      this.addFrom = {
        oneCustomerTaxId: row.oneCustomerTaxId,
        oneCustomerName: row.oneCustomerName,
        twoCustomerTaxId: row.twoCustomerTaxId,
        twoCustomerName: row.twoCustomerName,
        organizationId: row.organizationId,
        organizationName: row.organizationName

      }
      this.KHdialog = true
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          SVRadd(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.KHdialog = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 下发量
    xiafaliangFN (row) {
      this.KHMXdialog = true
      this.row = row
      this.MXsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        oneCustomerTaxId: this.row.oneCustomerTaxId,
        twoCustomerTaxId: this.row.twoCustomerTaxId,
        organizationId: this.row.organizationId
      }
      this.getMXList()
    },
    // 获取列表
    getMXList () {
      this.loading1 = true
      SVRlist(this.MXsearchFrom).then(res => {
        this.loading1 = false
        this.KHMXList = res.list
        this.MXtotla = res.total
      })
    },
    // 每页条数
    MXhandleSizeChange (val) {
      this.MXsearchFrom.pageSize = val
      this.getMXList()
    },
    // 当前页
    MXhandleCurrentChange (val) {
      this.MXsearchFrom.pageNo = val
      this.getMXList()
    },
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      cVirtualControlList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        organizationId: this.warehouseList[0].relTenantCode,
        oneCustomerTaxId: this.oneCustomerTaxId
      }
    },
    MXresetForm () {
      this.MXsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        oneCustomerTaxId: this.row.oneCustomerTaxId,
        twoCustomerTaxId: this.row.twoCustomerTaxId,
        organizationId: this.row.organizationId
      }
    },
    closeDialog () {
      this.addFrom = {}
      this.MXsearchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    }
  }
}
</script>

<style scoped lang='less'>

/deep/.inpBox .el-input__inner{
  width: 200px;
}
</style>
